const fadeIn = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3,
      type: 'spring',
    },
  },
  exit: {
    opacity: 0,
  },
};

export default fadeIn;
